<template>
  <div>
    <Spin size="large" fix v-if="loading"></Spin>
    <p>
      <img src="../../../../assets/images/weixin.png" class="QRtitle">
      <span class="QRspan">请人事使用微信扫码核验身份</span>
    </p>
    <div class="al">
      身份核验成功后自动提交
    </div>
    <div v-if="form.personnelId" class="personnelInfo">
      <div v-if="form.personnelId"><span>
          <Icon type="ios-person" size="20" />人事姓名：
        </span>{{form.personnelName}}</div>
      <div v-if="form.personnelId"><span>
          <Icon type="ios-card" size="20" />身份证：
        </span>{{form.personnelIDCardNo}}</div>
    </div>
    <div class="QRcode">
      <img :src="'data:image/png;base64,'+QRcode" alt="">
    </div>

    <div class="bom_btn">
      <div>
        <Button @click="next(null,-1)">上一步</Button>
      </div>
    </div>
    <!-- <Modal v-model="modalShow" title="Common Modal dialog box title" @on-ok="ok" @on-cancel="cancel">
      <p>Content of dialog</p>
      <p>Content of dialog</p>
      <p>Content of dialog</p>
    </Modal> -->
  </div>
</template>
<script>
export default {
  props: { form: { type: Object }, current: { type: Number } },
  data() {
    return {
      count: 0, //操作
      uploadData: {},
      QRshow: false,
      loading: false,
      QRcode: '',
      timer: null,
      key: null,
      appInfoDataType: this.$store.state.appInfoDataType,
      current_index: this.current,
      rules: {},
    }
  },
  mounted() {
    this.checkUserOpen()
  },
  methods: {
    //下一步
    next(name, val) {
      let _this = this
      //上一步
      if (name == null) {
        this.$emit('next', this.appInfoDataType['previewCA'])

        return
      }
      //下一步

      // await _this.$emit('submit', '/api/services/app/JZZJFApi/SaveAppPlusInfo', 0)
      // 是 直接提交
      // this.$emit('submit', '/api/services/app/JZZJFApi/SubmitApplication', 1, '提交成功')
      this.checkUserOpen()
      //   }
    },
    submit(name, type) {
      //type==true时暂存
      let _this = this
      this.$refs[name].validate((valid) => {
        if (!valid) {
          this.$Message.error('请将信息填写完整')
          return
        }
        this.$Modal.confirm({
          title: '请确认',
          content: `<p>是否提交信息</p>`,
          okText: '是',
          cancelText: '否',
          onOk: () => {
            _this.$emit('submit')
          },
        })
      })
    },
    //关闭核验经办人弹窗
    colseQR() {
      this.QRshow = false
      clearTimeout(this.timer)
      this.timer = null
    },

    // 打开核验经办人弹窗获取二维码
    async checkUserOpen() {
      this.QRshow = true
      this.loading = true

      this.key = this.form.guid + '|' + new Date().getTime()
      let { data } = await this.$Ajax.get(
        '/api/services/app/JZZJFApi/GetCheckApplicationQR?key=' + this.key
      )
      // let { data } = await this.$Ajax.get(
      //   '/api/services/app/JZZJFApi/GetCheckApplicationQR?guid=' + this.form.guid
      // )
      this.QRcode = data.result.qrBase64String
      this.loading = false
      if (this.QRshow) {
        this.checkUser(data.result.contextId)
      }
    },
    // 核验经办人 获取个人信息轮询
    checkUser(contextId) {
      let _this = this
      const poll = async () => {
        let { data } = await this.$Ajax.get(`/api/services/app/JZZJFApi/CheckApplicationResult`, {
          params: { contextId },
        })
        if (data.result.success) {
          // _this.bindUserColse()
          _this.colseQR()
          // this.$Modal.confirm({
          //   title: '提示',
          //   content: '<p>确认提交申请？</p>',
          //   okText: '是',
          //   cancelText: '否',
          //   onOk: async () => {
          // 是 直接提交
          try {
            this.form.isPersonalInfoChanged = null
            this.form.isPlusMaterialsUploadComplete = true
            await this.$emit(
              'submit',
              '/api/services/app/JZZJFApi/SubmitApplication',
              1,
              '提交成功'
            )
          } catch (error) {
            _this.$Message.error({
              content: '操作失败',
              background: true,
              duration: 6,
            })
          }
          //   },
          //   onCancel: () => {
          //   },
          // })
        } else {
          _this.timer = setTimeout(poll, 2500)
        }
      }
      poll()
    },
  },
  destroyed() {
    this.colseQR()
  },
}
</script>
<style lang="less" scoped>
p {
  text-align: center;
  margin-top: 20px;
}
.QRtitle {
  width: 30px !important;
}
.QRspan {
  font-size: 22px !important;
}
.QRcode {
  margin: 20px 0px 40px 0px;
}
.al {
  display: flex;
  justify-content: center;
  color: #ff9900;
}
</style>